/** 잘린 요소를 이벤트 위임으로 찾기 위한 마커. `TruncatedText`가 달고, `TruncationTooltipHost`가 판별. */
export const TRUNCATE_ATTR = "data-c6-truncate";
/** 다중 행(line-clamp) 마커 — 있으면 세로(scrollHeight)+가로로 잘림을 잰다. 값 = clamp 행 수. */
export const TRUNCATE_LINES_ATTR = "data-c6-truncate-lines";
/**
 * 툴팁 내용 오버라이드. 기본은 잘린 요소의 `textContent`인데, composite(다중 span·포맷 노드)이거나
 * 보이는 텍스트와 다른 전체 값을 띄우고 싶을 때 이 속성으로 정답 문자열을 직접 준다.
 */
export const TRUNCATE_TEXT_ATTR = "data-c6-truncate-text";

/** 잘린 요소의 툴팁 내용 — 오버라이드 속성이 있으면 그 값, 없으면 textContent. */
export function readTruncationText(el: HTMLElement): string {
  return el.getAttribute(TRUNCATE_TEXT_ATTR) ?? el.textContent ?? "";
}

/**
 * 요소의 내용이 지금 실제로 잘렸는지.
 *
 * `text-overflow: ellipsis`/`line-clamp`는 "잘렸다"는 신호를 이벤트로 주지 않으므로, 렌더된 내용
 * 크기(`scroll*`)가 보이는 박스(`client*`)보다 큰지로 판별한다. sub-pixel 반올림으로 딱 맞을 때 1px
 * 오차가 나므로 `> 1` 여유를 둔다(RFC-truncation-tooltip §성능). 렌더 시점이 아니라 **hover 시점에 1회** 부른다.
 *
 * 단일 행은 가로만 본다. 다중 행(line-clamp)은 세로가 주지만, 끊기지 않는 토큰(긴 URL/ID/경로)이
 * 줄바꿈 없이 가로로 잘리면서 세로는 딱 맞는 경우가 있어 **가로도 함께** 본다.
 */
export function isTextOverflowing(el: HTMLElement, multiline = false): boolean {
  const widthClipped = el.scrollWidth - el.clientWidth > 1;
  if (!multiline) return widthClipped;
  return el.scrollHeight - el.clientHeight > 1 || widthClipped;
}
